export default {
  keyPress: 'app-keypress'
}


/** WEBPACK FOOTER **
 ** ./src/topics.js
 **/